import { Input } from "@/shared/ui/Input";
import { DatePicker } from "@/shared/ui/DatePicker";

// One editable cell in the agreement preview table. Money/number cells use type=text +
// inputMode=numeric (task 0072 lesson: type=number breaks thousands separators and the empty
// state). Dates use the brand DatePicker (Radix Popover + Calendar, portal-escaped so it is
// never clipped by the table's overflow container). Dense sizing matches the table row scale;
// the width comes from the caller via `className` (twMerge override of the primitive's w-full).
export function EditCell({
  value,
  onChange,
  kind = "text",
  className = "w-28",
}: {
  value: string;
  onChange: (v: string) => void;
  kind?: "text" | "numeric" | "date";
  className?: string;
}) {
  if (kind === "date") {
    // DatePicker uses a Radix Popover portal, so it escapes the table overflow and renders
    // the calendar correctly. Value/onChange contract: ISO "YYYY-MM-DD" string, "" = empty.
    return (
      <div className={className}>
        <DatePicker value={value} onChange={onChange} dense />
      </div>
    );
  }

  return (
    <Input
      inputSize="dense"
      type="text"
      inputMode={kind === "numeric" ? "numeric" : undefined}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
    />
  );
}
